import React from 'react';

export const ParticlesBg = () => (
  <div className="particles">
    <div className="particle" />
    <div className="particle" />
    <div className="particle" />
    <div className="particle" />
    <div className="particle" />
    <div className="particle" />
    <div className="particle" />
    <div className="particle" />
  </div>
);

export const NeuralGrid = () => (
  <div className="neural-grid" />
);
